import { useEffect, useState } from "react";

export default function Countdown24({ className = "", testid }) {
  const [secs, setSecs] = useState(24 * 3600);
  useEffect(() => {
    const i = setInterval(() => setSecs((s) => (s <= 0 ? 24 * 3600 : s - 1)), 1000);
    return () => clearInterval(i);
  }, []);
  const h = String(Math.floor(secs / 3600)).padStart(2, "0");
  const m = String(Math.floor((secs % 3600) / 60)).padStart(2, "0");
  const s = String(secs % 60).padStart(2, "0");
  const progress = 1 - secs / (24 * 3600);
  return (
    <div className={className} data-testid={testid}>
      <div className="font-mono tabular-nums whitespace-nowrap leading-none text-metal text-[clamp(3rem,11.5vw,9.5rem)] tracking-tight">
        {h}:{m}:{s}
      </div>
      <div className="mt-6 h-px w-full bg-silver/10 relative overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 bg-glow/70 transition-[width] duration-1000 ease-linear"
          style={{ width: `${progress * 100}%` }}
        />
      </div>
      <div className="mt-3 flex justify-between font-mono text-[10px] tracking-[0.3em] text-steel">
        <span>GESTIÓN INICIADA</span>
        <span>TÉCNICO EN TU COMERCIO</span>
      </div>
    </div>
  );
}
